module.exports = __webpack_public_path__ + "static/img/13.4bac035.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/13.jpg
// module id = WQ9N
// module chunks = 0